const steps: Map<number, string> = new Map([[1, 'bankDetailsValid'], [2, 'investmentDetailsValid'], [3, 'tcsDetailsValid']]);

export class ApplicationValidity {
    public bankDetailsValid = false;
    public investmentDetailsValid = false;
    public tcsDetailsValid = false;
}
